import { Select } from "antd";

const SelectOptn = ({
  name,
  size,
  className,
  allowClear,
  placeholder,
  options,
  mode,
  onChange,
}) => {
  return (
    <Select
      showSearch
      name={name}
      size={size}
      className={className}
      allowClear="true"
      mode={mode}
      placeholder={placeholder}
      options={options}
      onChange={onChange}
      filterOption={(input, option) =>
        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      }
    />
  );
};

export default SelectOptn;
